import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";
import useTableFijo from "../../useTableFijo";
import moment from "moment";
import { InfoButton } from "../../../ui/buttons/Button";

const TablaPagosComercio = (props) => {
  const espiritu = localStorage.getItem("espiritu");
  const fechaSistema = localStorage.getItem("fechasistema");

  let op = require("../../../../src/modulos/datos");
  const headCells = [
    {
      id: "anio",
      label: "AÑO",
      width: "50px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "mes",
      label: "MES",
      width: "80px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "monto",
      label: "MONTO",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "intereses",
      label: "INTERES MORA",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "multa",
      label: "MULTAS",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "recargo",
      label: "RECARGOS",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descuento",
      label: "DESCUENTO",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "recibo",
      label: "NRO. RECIBO",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "fechapago",
      label: "FECHA DE PAGO",
      width: "150px",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const [records, setRecords] = useState([]);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    320,
  );
  useEffect(() => {
    if (props.tabpago) {
      setRecords(props.tabpago);
    }
  }, [props.tabpago]);

  const imprimirDeuda = (reporte) => (event) => {
    event.preventDefault();
    var idcomercio = props.idcomercio;
    reporte = "HisPago_IndCom";
    window.open(
      op.reportes +
        "/actividadeconomica?" +
        "reporte=" +
        reporte +
        `&fecha=${fechaSistema}` +
        "&id=" +
        idcomercio +
        `&espiritu=${espiritu}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  return (
    <div className="col-12 m-0 p-0">
      <div className="col-12 m-0 my-2 p-0 d-flex justify-content-end">
        <InfoButton
          icon="fa-print m-0"
          onClick={imprimirDeuda("HisPago_IndCom")}
        />
      </div>
      <div className="col-12 m-0 p-0">
        <TblContainer
          container={{
            height: 250,
            width: "100%",
            overflow: "auto",
            padding: "2px",
          }}
        >
          <TblHead />
          <tbody>
            {records &&
              records.map((item) => (
                <tr key={item.anio + item.mes} style={{ padding: "0" }}>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.anio}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.mes}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                      item.monto.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                      item.intereses.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                      item.multa.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                      item.recargo.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {formatMoneda(
                      item.descuento.toString().replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {item.recibo === null ? "" : item.recibo.trim()}
                  </td>
                  <td style={{ fontSize: "10px", textAlign: "center" }}>
                    {moment.utc(item.fechapago).format("DD/MM/YYYY")}
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
      </div>
    </div>
  );
};

export default TablaPagosComercio;
